import Component from './router';
export default Component;
